import React, { useEffect } from "react";
import { useShellStore } from "@/features/shell/stores/shellStore";
import { useSearchParams } from "@/hooks/useSearchParams";
import { withdrawModalParams } from "@/features/wallet/components/withdraw/models/withdrawModalParams";
import { WithdrawModal } from "./WithdrawModal";

/**
 * The app-wide withdraw modal, openable from a url so deep links land straight
 * in it
 */
const WithdrawModalContainer = () => {
  const modal = useShellStore((state) => state.modal);
  const setModal = useShellStore((state) => state.setModal);

  const { searchParams, setSearchParams } =
    useSearchParams(withdrawModalParams);
  const { withdrawalModal } = searchParams;

  const isOpen = modal === "withdraw";

  // the url only signals inbound. it opens the modal and is consumed on the way
  // in, leaving the layout store as the single owner of the open state
  useEffect(() => {
    if (!withdrawalModal) {
      return;
    }

    setModal("withdraw");
    setSearchParams({ withdrawalModal: undefined }, { replace: true });
  }, [withdrawalModal]);

  const handleOpenChange = (open: boolean) => {
    if (open) {
      return;
    }

    setModal(null);
  };

  return <WithdrawModal isOpen={isOpen} onOpenChange={handleOpenChange} />;
};

export { WithdrawModalContainer };
